@for (menuItem of displayItems; track menuItem) {
<ng-container class="dashboard__sidenav-list_item">
  <!-- section -->
  @if (menuItem.type === 'section' && filter(menuItem.face) && !iconOnlyMode) {
  <mat-list-item class="dashboard__section" [disabled]="menuItem.loading">
    @if (!iconOnlyMode) {
    <span class="dashboard__section__title">{{ menuItem.face }}</span>
    }
  </mat-list-item>
  }

  <!-- Plain link / icon-only entry -->
  @if ( (menuItem.type === 'link' && filter(menuItem.face) && !menuItem.children
  && isVisible(menuItem.key)) || (iconOnlyMode && menuItem.children &&
  filterMatch(menuItem)) ) {
  <mat-list-item
    matRipple
    id="side_menu_list_item_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    class="dashboard__sidenav-list_item side-menu__list-item menu-left-border mat-mdc-list-item-interactive"
    matTooltipPosition="right"
    [routerLink]="
      !iconOnlyMode || !menuItem.children ? menuItem.link : undefined
    "
    [class.side-menu__item--active]="isMenuOrChildActive(menuItem)"
    [class.mat-list-item-content]="iconOnlyMode"
    [class.mat-mdc-list-item-row]="iconOnlyMode"
    [matTooltip]="menuItem.tooltip"
    [disabled]="menuItem.loading"
    (click)="itemSelect(menuItem)"
    (contextmenu)="
      onNavLinkContextMenu($event, menuItem.link, menuItem.loading)
    "
  >
    @if (!iconOnlyMode) {
    <div
      matListItemTitle
      class="mat-mdc-list-item-gutters side-menu__item-label"
    >
      {{ menuItem.face }}
    </div>
    } @if (!menuItem.children) {
    <mat-icon
      matListItemIcon
      id="side_menu_list_item_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      attr.data-testid="side_menu_list_item_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      class="side-menu__item-icon mr-0"
      [fontSet]="iconFontSet(menuItem)"
    >
      @if (!menuItem.loading) {
      <span>{{ menuItem.icon }}</span>
      } @if (menuItem.loading) {
      <mat-spinner [diameter]="24"></mat-spinner>
      }
    </mat-icon>
    } @if (iconOnlyMode && menuItem.children) { @if (!menuItem.loading) {
    <mat-icon
      id="side_menu_list_item_expandable_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      attr.data-testid="side_menu_list_item_expandable_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      matListItemIcon
      class="dashboard__sidenav-icon-only-mode side-menu__item-icon"
      [fontSet]="iconFontSet(menuItem)"
      #afterMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="afterMenu"
      (click)="afterMenuTrigger.openMenu()"
      >{{ menuItem.icon }}</mat-icon
    >
    } @if (menuItem.loading) {
    <mat-icon matListItemIcon>
      <mat-spinner [diameter]="27"></mat-spinner>
    </mat-icon>
    } }
    <div class="dropdown-content movelist">
      <mat-menu #afterMenu="matMenu" class="side-menu">
        @for (subMenuItem of menuItem.children; track subMenuItem) {
        <div>
          @if ( menuItem.type === 'group' && filter(subMenuItem.face) &&
          subMenuItem.type !== 'button' ) {
          <mat-list-item
            [disableRipple]="true"
            class="dashboard__sidenav-list_item"
            [ngStyle]="{ 'margin-top': !iconOnlyMode ? '0px' : '40px' }"
            [disabled]="subMenuItem.loading"
          >
            <button
              id="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_sub_menu_item_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_sub_menu_item_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              [disableRipple]="true"
              mat-menu-item
              class="mat-menu-item-contents"
              [routerLinkActive]="['accent-color']"
              [routerLink]="subMenuItem.link"
              [routerLinkActiveOptions]="activeMatchOptions"
            >
              {{ subMenuItem.face }}
              <mat-icon
                matListIcon
                style="padding-right: 10px; padding-left: 25px"
                [routerLink]="subMenuItem.link"
                [routerLinkActiveOptions]="activeMatchOptions"
                [fontSet]="iconFontSet(subMenuItem)"
                >{{ subMenuItem.icon }}
              </mat-icon>
            </button>
          </mat-list-item>
          } @if ( menuItem.type === 'group' && filter(subMenuItem.face) &&
          subMenuItem.type === 'button' ) {
          <mat-list-item
            [disableRipple]="true"
            class="dashboard__sidenav-list_item"
            [ngStyle]="{ 'margin-top': !iconOnlyMode ? '0px' : '40px' }"
            [disabled]="subMenuItem.loading"
          >
            <div class="button-container">
              <button
                mat-stroked-button
                (click)="itemSelect(subMenuItem)"
                class="button-popup"
              >
                {{ subMenuItem.face }}
              </button>
            </div>
          </mat-list-item>
          }
        </div>
        }
      </mat-menu>
    </div>
  </mat-list-item>
  }
  <!-- Icon only mode (end) -->

  <!-- ----------------------------- List Items with children ----------------------------------- -->
  @if ( menuItem.children && !iconOnlyMode && (filter(menuItem.face) ||
  bulkFilter(menuItem)) && filterMatch(menuItem) ) {
  <mat-accordion
    id="side_menu_list_item_expandable_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    attr.data-testid="side_menu_list_item_expandable_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    displayMode="flat"
    class="child-headers-align"
    multi
  >
    <mat-expansion-panel
      #expPanel="matExpansionPanel"
      style="padding: 0px; border: none"
      class="rounded-0 side-menu__expansion-panel"
      [hideToggle]="true"
      [expanded]="menuItem.key !== 'REFERENCES' ? menuItem.expanded : false"
      (expandedChange)="menuItem.expanded = $event"
      (opened)="beforeExpand(menuItem)"
    >
      <mat-expansion-panel-header
        matRipple
        class="rounded-0 dashboard__sidenav-list_item side-menu__expansion-header"
        [class.side-menu__core-expansion-header]="
          menuItem.key === 'CORE' || menuItem.key === 'SAAS'
        "
        [collapsedHeight]="
          menuItem.key === 'CORE' || menuItem.key === 'SAAS' ? '32px' : '42px'
        "
        [expandedHeight]="
          menuItem.key === 'CORE' || menuItem.key === 'SAAS' ? '32px' : '42px'
        "
      >
        <mat-panel-title class="side-menu__expansion-title">
          @if (menuItem.icon) {
          <mat-icon
            class="side-menu__expansion-icon side-menu__item-icon mr-0"
            [fontSet]="iconFontSet(menuItem)"
            >{{ menuItem.icon }}</mat-icon
          >
          }
          <span class="side-menu__expansion-label">{{ menuItem.face }}</span>
          <mat-icon
            class="side-menu__expansion-toggle mr-0"
            aria-hidden="true"
            fontSet="material-icons-outlined"
            >{{ expPanel.expanded ? 'remove' : 'add' }}</mat-icon
          >
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div
        class="side-menu__nested-group"
        [class.side-menu__nested-group--main]="
          menuItem.key === 'CORE' || menuItem.key === 'SAAS'
        "
      >
        @for (subMenuItem of menuItem.children; track subMenuItem) {
        <div>
          @if ( subMenuItem.type === 'section' && filter(subMenuItem.face) &&
          !iconOnlyMode ) {
          <mat-list-item
            class="side-menu__inline-section"
            [disabled]="subMenuItem.loading"
          >
            @if (!iconOnlyMode) {
            <span class="side-menu__inline-section__title" matLine>{{
              subMenuItem.face
            }}</span>
            }
          </mat-list-item>
          } @if ( (isLinkType(subMenuItem) && filter(subMenuItem.face) &&
          !subMenuItem.children && isVisible(subMenuItem.key)) || (iconOnlyMode
          && subMenuItem.children) ) {
          <mat-list-item
            matRipple
            id="side_menu_list_item_{{
              menuItem.face.toLowerCase().replaceAll(' ', '_')
            }}_sub_menu_item_{{
              subMenuItem.face.toLowerCase().replaceAll(' ', '_')
            }}"
            attr.data-testid="side_menu_list_item_{{
              menuItem.face.toLowerCase().replaceAll(' ', '_')
            }}_sub_menu_item_{{
              subMenuItem.face.toLowerCase().replaceAll(' ', '_')
            }}"
            [disableRipple]="true"
            class="dashboard__sidenav-list_item side-menu__list-item menu-left-border mat-mdc-list-item-interactive"
            [ngClass]="{
              'side-menu__list-item--child':
                menuItem.key !== 'CORE' && menuItem.key !== 'SAAS',
              'side-menu__list-item--core-root':
                menuItem.key === 'CORE' || menuItem.key === 'SAAS'
            }"
            [routerLink]="subMenuItem.link"
            [routerLinkActive]="['side-menu__item--active']"
            [routerLinkActiveOptions]="activeMatchOptions"
            [class.mat-mdc-list-item-content]="iconOnlyMode"
            [disabled]="subMenuItem.loading"
            (click)="itemSelect(subMenuItem)"
            (contextmenu)="
              onNavLinkContextMenu(
                $event,
                subMenuItem.link,
                subMenuItem.loading
              )
            "
          >
            @if ((menuItem.key === 'CORE' || menuItem.key === 'SAAS') &&
            subMenuItem.icon) {
            <mat-icon
              matListItemIcon
              class="side-menu__item-icon mr-0"
              [fontSet]="iconFontSet(subMenuItem)"
            >
              @if (!subMenuItem.loading) {
              <span>{{ subMenuItem.icon }}</span>
              } @if (subMenuItem.loading) {
              <mat-spinner [diameter]="24"></mat-spinner>
              }
            </mat-icon>
            } @if (!iconOnlyMode) {
            <div
              matListItemTitle
              class="mat-mdc-list-item-gutters side-menu__item-label"
              [class.side-menu__item-label--nested]="
                menuItem.key !== 'CORE' && menuItem.key !== 'SAAS'
              "
            >
              @if (subMenuItem.loading) {
              <span class="side-menu__nested-spinner-wrap">
                <mat-spinner [diameter]="18"></mat-spinner>
              </span>
              } @if (!subMenuItem.loading) {
              <span>{{ subMenuItem.face }}</span>
              }
            </div>
            }
          </mat-list-item>
          }

          <!-- Nested expandable group under CORE (Authorization, Integrations, …) -->
          @if ( subMenuItem.type === 'group' && subMenuItem.children &&
          !iconOnlyMode && (filter(subMenuItem.face) || bulkFilter(subMenuItem))
          ) {
          <mat-accordion
            class="child-headers-align side-menu__nested-accordion"
            displayMode="flat"
            multi
          >
            <mat-expansion-panel
              #nestedExp="matExpansionPanel"
              class="side-menu__expansion-panel side-menu__expansion-panel--nested"
              [hideToggle]="true"
              [expanded]="
                subMenuItem.key !== 'REFERENCES' ? subMenuItem.expanded : false
              "
              (expandedChange)="subMenuItem.expanded = $event"
              (opened)="beforeExpandNested(menuItem, subMenuItem)"
            >
              <mat-expansion-panel-header
                matRipple
                class="side-menu__expansion-header side-menu__expansion-header--nested"
                [class.side-menu__item--active]="
                  isMenuOrChildActive(subMenuItem)
                "
                [collapsedHeight]="'42px'"
                [expandedHeight]="'42px'"
              >
                <mat-panel-title class="side-menu__expansion-title">
                  @if (subMenuItem.icon) {
                  <mat-icon
                    class="side-menu__expansion-icon side-menu__item-icon mr-0"
                    [fontSet]="iconFontSet(subMenuItem)"
                    >{{ subMenuItem.icon }}</mat-icon
                  >
                  }
                  <span class="side-menu__expansion-label">{{
                    subMenuItem.face
                  }}</span>
                  <mat-icon
                    class="side-menu__expansion-toggle mr-0"
                    aria-hidden="true"
                    fontSet="material-icons-outlined"
                    >{{ nestedExp.expanded ? 'remove' : 'add' }}</mat-icon
                  >
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="side-menu__nested-group side-menu__nested-group--sub">
                @for (leaf of subMenuItem.children; track leaf) {
                <div>
                  @if ( leaf.type === 'section' && filter(leaf.face) &&
                  !iconOnlyMode ) {
                  <mat-list-item
                    class="dashboard__nested-section"
                    [disabled]="leaf.loading"
                  >
                    <span class="dashboard__nested-section__title" matLine>{{
                      leaf.face
                    }}</span>
                  </mat-list-item>
                  } @if ( leaf.type === 'link' && filter(leaf.face) &&
                  !leaf.children && isVisible(leaf.key) ) {
                  <mat-list-item
                    matRipple
                    class="dashboard__sidenav-list_item side-menu__list-item side-menu__list-item--child side-menu__list-item--leaf mat-mdc-list-item-interactive"
                    [routerLink]="leaf.link"
                    [routerLinkActive]="['side-menu__item--active']"
                    [routerLinkActiveOptions]="activeMatchOptions"
                    [disabled]="leaf.loading"
                    (click)="itemSelect(leaf)"
                    (contextmenu)="
                      onNavLinkContextMenu($event, leaf.link, leaf.loading)
                    "
                  >
                    @if (leaf.icon) {
                    <mat-icon
                      matListItemIcon
                      class="side-menu__item-icon mr-0"
                      [fontSet]="iconFontSet(leaf)"
                    >
                      @if (!leaf.loading) {
                      <span>{{ leaf.icon }}</span>
                      } @if (leaf.loading) {
                      <mat-spinner [diameter]="24"></mat-spinner>
                      }
                    </mat-icon>
                    }
                    <div
                      matListItemTitle
                      class="mat-mdc-list-item-gutters side-menu__item-label side-menu__item-label--nested"
                    >
                      @if (leaf.loading) {
                      <span class="side-menu__nested-spinner-wrap">
                        <mat-spinner [diameter]="18"></mat-spinner>
                      </span>
                      } @if (!leaf.loading) {
                      <span>{{ leaf.face }}</span>
                      }
                    </div>
                  </mat-list-item>
                  } @if (leaf.type === 'button') {
                  <div class="button-container">
                    <button mat-stroked-button (click)="itemSelect(leaf)">
                      {{ leaf.face }}
                    </button>
                  </div>
                  }
                </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          } @if (subMenuItem.type === 'button') {
          <div class="button-container" style="margin-bottom: 10px">
            <button
              id="side_menu_list_item_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_btn{{
                subMenuItem.face
                  .toLowerCase()
                  .replace('+', '')
                  .replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_item_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_btn{{
                subMenuItem.face
                  .toLowerCase()
                  .replace('+', '')
                  .replaceAll(' ', '_')
              }}"
              mat-stroked-button
              (click)="itemSelect(subMenuItem)"
            >
              {{ subMenuItem.face }}
            </button>
          </div>
          }
        </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  }
  <!-- ----------------------------- List Items with children ----------------------------------- -->
</ng-container>
}

<div
  class="side-menu__nav-context-anchor"
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="navLinkContextMenu"
  #navLinkContextMenuTrigger
></div>
<mat-menu #navLinkContextMenu="matMenu">
  <button mat-menu-item type="button" (click)="openContextMenuLinkInNewTab()">
    <mat-icon>open_in_new</mat-icon>
    <span>{{ 'pages.dashboard.open-in-new-tab' | translate }}</span>
  </button>
</mat-menu>
